import React from "react";
import { Badge } from "react-bootstrap";
import {
  FaGraduationCap, FaInfoCircle
} from "react-icons/fa";
import GenericCrudPage from '../components/GenericCrudPage'; // Assuming this path is correct

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Validation for Degree form
const validateDegreeForm = (form) => {
  const errors = {};
  if (!form.exName.trim()) errors.exName = "Degree Name is required";
  if (form.exName.length > 100) errors.exName = "Degree Name must be less than 100 characters";
  return errors;
};

// Configuration for Degree CRUD operations
const degreeConfig = {
  baseUrl: BASE_URL,
  endpoints: {
    fetch: '/master/getDegree',
    save: '/master/saveDegree',
    update: '/master/updateDegree',
    delete: '/master/deleteDegree'
  },
  validateForm: validateDegreeForm,
  initialFormState: {
    exName: "", exDescription: "", exIsActive: 1, user: ""
  },
  entityName: 'Degree'
};

// Form fields configuration
const formFields = [
  { name: "exName", label: "Degree Name", icon: FaGraduationCap, required: true },
  { name: "exDescription", label: "Description", icon: FaInfoCircle, as: "textarea", rows: 3 },
];

// Table columns configuration
const tableColumns = [
  {
    key: 'exName',
    label: 'Degree Name',
    sortable: true,
    render: (degree) => (
      <div className="fw-bold">{degree.exName}</div>
    )
  },
  { key: 'exDescription', label: 'Description', sortable: true, className: "text-truncate", style: { maxWidth: '250px' } }
];

// CSV export headers
const csvHeaders = [
  { key: 'exName', label: 'Degree Name' },
  { key: 'exDescription', label: 'Description' },
  { key: 'exIsActive', label: 'Status' }
];

// Transform form data to API payload
// The userId is passed from GenericCrudPage
const transformPayload = (form, editId, userId) => ({
  exName: form.exName.trim(),
  exDescription: form.exDescription.trim(),
  exIsActive: form.exIsActive,
  user: userId, // Ensure user is passed
  ...(editId && { id: editId })
});

// Transform API data to form
const transformToForm = (degree) => ({
  exName: degree.exName || "",
  exDescription: degree.exDescription || "",
  exIsActive: degree.exIsActive,
  user: degree.user || "", // User ID from fetched data
});

// Get view modal fields
const getViewFields = (degree) => {
  if (!degree) return [];
  return [
    { label: "Degree Name", value: degree.exName, icon: FaGraduationCap },
    { label: "Description", value: degree.exDescription, icon: FaInfoCircle, fullWidth: true },
  ];
};

export default function DegreePage() {
  return (
    <GenericCrudPage
      title="Degrees" // This will be the header text for the page
      config={degreeConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      emptyIcon={FaGraduationCap}
      searchPlaceholder="Search by name, description..."
      csvHeaders={csvHeaders}
      csvFilename="degrees_export.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
    />
  );
}